module.exports = __webpack_public_path__ + "static/m-JHernandez-b66536d222fdebc82651a3415b0a9dac.jpg";